export enum SdCardStatus {
    UNINSERTED,
    INSERTED,
    MOUNTED,
    INSERT_AND_MOUNT,
    ERROR = 8,
}

export enum SdCardDiskStatus {
    UNFORMATTED,
    NORMAL,
    OFFLINE,
    FORMATTING,
    BAD,
    LOADING,
    NONE,
}

export enum SdCardFullStatus {
    NO,
    YES,
}

export enum SdEncryptStatus {
    UNENCRYPTED,
    ENCRYPTED_SUCCESS,
    ENCRYPTED_FAILED,
}

export enum NasRecycle {
    NO,
    YES,
}

export enum NasMountType {
    NFS,
    SMB_CIFS,
}

export enum NasStatus {
    UNFORMATTED,
    NORMAL,
    OFFLINE,
    FORMATTING,
}

export interface NasItem {
    NasIndex: number;
    NasAddress: string;
    NasFilePath: string;
    NasRecycle: NasRecycle;
    NasMountType: NasMountType;
    NasTotalSize: string;
    NasFreeSize: string;
    NasUserName: string;
    NasPassword: string;
    NasStatus: NasStatus;
}

export interface PTZStorageSetting {
    DevMac: string;
    SdcardStatus: SdCardStatus;
    SdcardDiskStatus: SdCardDiskStatus;
    SdcardFullStatus: SdCardFullStatus;
    SdcardTotalSize: string;
    SdcardFreeSize: string;
    SdcardUseSize: string;
    SdEncryptStatus: SdEncryptStatus;
    SdFormatTime: number;
    NasList: NasItem[];
}
